"use client";

import Image from 'next/image'
import React, { useState } from 'react'
import Navbar from '../layout/navbar/Navbar'
import Button from '../ui/Button'
import ContactModal from './ContactModal'
import { useRouter } from 'next/navigation'

const Hero = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const router = useRouter();

    return (
        <section className="relative w-full lg:h-140 bg-[#1B365E]">
            <div className='relative z-100'>
                <Navbar />
            </div>
            {/* Background Image */}
            <div className="relative w-full h-48.25 sm:absolute sm:inset-0 sm:h-full z-0">
                <Image
                    src="/assets/hero-image.png"
                    alt="Hero Background"
                    title='Hero Background'
                    fill
                    placeholder='blur'
                    priority
                    className="h-full object-cover w-full"
                    blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJ..."
                />

                <div className="sm:hidden block font-red-hat font-normal text-[30px] leading-9.25 text-white text-left tracking-[1.2px] absolute z-10 px-4 pt-12.25">
                    Peu importe votre besoin, <br /> nous avons LA formation.
                </div>
            </div>


            <div className='px-4 xl:px-10 w-full relative z-10'>
                <div className='max-w-full mx-auto flex lg:items-end lg:flex-row flex-col justify-between lg:gap-0 gap-6.5 pb-[69.11px] lg:pb-0 sm:pt-22'>
                    <div>
                        <h1 className="sm:block hidden font-red-hat font-normal xl:text-[60px] text-[30px] sm:text-[50px] xl:leading-16.5 sm:leading-14 leading-9.25 text-white text-left tracking-[1.2px]">
                            Peu importe votre besoin, <br /> nous avons LA formation.
                        </h1>
                        <p className='text-[20px] text-white leading-7.5 font-medium my-4 sm:my-5'>
                            Des formations sélectionnées avec soin, <br />
                            pour répondre à un réel besoin.
                        </p>
                        <p className='text-[14px] sm:text-[16px] text-white leading-5 sm:leading-6.5 font-normal'>
                            Des formateurs experts, des études de cas réelles pour dévoiler votre vrai potentiel. <br />
                            Faites le premier pas dès maintenant, votre réussite commence ici et maintenant.
                        </p>

                        <div className='mt-6 sm:mt-8 flex items-center sm:flex-row flex-col gap-6.5 sm:gap-8'>
                            <Button
                                variant="primary"
                                className='w-full sm:w-fit'
                                onClick={() => router.push('/quiz')}
                            >
                                Se laisser guider
                            </Button>
                            <Button variant="gradient" className='w-full sm:w-fit' onClick={() => router.push('/formations')}>
                                Choisir votre formation
                            </Button>
                        </div>
                    </div>

                    <div className='bg-[#1B515E] rounded-lg xl:-mb-6 sm:w-76.75 flex justify-center md:justify-start'>
                        <Image src='/assets/icons/Evalutation-v2.svg' alt='evalutation' title='evalutation' width={307} height={74} className='w-76.75 h-18.5' />
                    </div>
                </div>
            </div>

            <div className="flex items-center bg-white rounded-[40px] border-b border-[#40BFDE] py-3 px-4 justify-center absolute left-1/2 -translate-x-1/2 -bottom-5">
                <Image src='/assets/small-logo.svg' alt='logo' title='logo' width={30} height={17} />
            </div>

            <ContactModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
            />
        </section >
    )
}

export default Hero